"use client";

import { c as _c } from "react/compiler-runtime";
import { useMovieActivityContext } from "src/components/film/filmwebid/MovieActivityContextTypes";
import RatingPanel from "src/components/filmwebid/RatingPanel";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import StarSvg from "src/components/svg/StarSvg";
import getFraction from "src/lib/filmwebid/getFraction";
import type { IFilmwebIdMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";
import classNames from "classnames";
import { useState } from "react";
import styles from "./UserRatings.module.css";
import { times } from "lodash";
import { createPortal } from "react-dom";
import { locale } from "@locale";
import { formatLocaleString } from "src/lib/locale/helpers";
import RatingDisplay from "src/components/ratingdisplay/RatingDisplay";

//#region [Props]
type UserRatingsProps = {
  className?: string;
  movieIdentifier: IFilmwebIdMovieIdentifier | null | undefined;
  maxRatingValue: number;
};
//#endregion

//#region [Component]
export default function UserRatings(t0) {
  const $ = _c(36);
  const {
    className,
    movieIdentifier,
    maxRatingValue
  } = t0;
  const movieActivityContext = useMovieActivityContext();
  const [showRatingPanel, setShowRatingPanel] = useState(false);
  const isLoading = movieActivityContext.isLoading;
  let t1;
  if ($[0] !== movieActivityContext) {
    t1 = doUpdate => {
      setShowRatingPanel(false);
      if (doUpdate) {
        movieActivityContext.activityUpdater();
      }
    };
    $[0] = movieActivityContext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onRatingPanelClose = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== className || $[3] !== isLoading || $[4] !== maxRatingValue || $[5] !== movieActivityContext.activity) {
    const ratingNumberer = times(maxRatingValue, _temp);
    if ($[11] !== className || $[12] !== isLoading) {
      t2 = classNames(styles.SRatingsDisplay, className, {
        [styles.IsLoading]: isLoading
      });
      $[11] = className;
      $[12] = isLoading;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    if ($[14] !== isLoading) {
      t3 = isLoading && <LoadingIndicator />;
      $[14] = isLoading;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    const t7 = isLoading || !movieActivityContext.activity?.movieUserInteraction?.rating ? locale.ratings.headingCta : locale.ratings.headingAvg;
    if ($[16] !== t7) {
      t4 = <h2 className={styles.SHeading}>{t7}</h2>;
      $[16] = t7;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    let t8;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = () => setShowRatingPanel(true);
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    const t9 = movieActivityContext.activity?.movieStats?.ratingAverage ?? 0;
    if ($[19] !== t9) {
      t5 = <div className={styles.SStarContainer} onClick={t8}><RatingDisplay ratingValue={t9} className={styles.SAverageMarkerStar} /></div>;
      $[19] = t9;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    t6 = !isLoading && <>{(movieActivityContext.activity?.movieStats?.ratingCount ?? 0) > 0 && <div className={styles.SNumRated}>{formatLocaleString(locale.ratings.ratingCount, {
          ratingCount: (movieActivityContext.activity?.movieStats?.ratingCount ?? 0).toString()
        })}</div>}{(movieActivityContext.activity?.movieUserInteraction?.rating ?? 0) > 0 && <><h4 className={classNames(styles.SHeading, styles.SYourRatingHeading)}>{locale.ratings.yourRating}</h4><div className={styles.SStarContainer}>{ratingNumberer.map(i_0 => <StarSvg key={`sc2_${i_0}`} className={styles.SUserRatingMarkerStar} selected={movieActivityContext.activity.movieUserInteraction.rating >= i_0} />)}</div></>}</>;
    $[2] = className;
    $[3] = isLoading;
    $[4] = maxRatingValue;
    $[5] = movieActivityContext.activity;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[21] !== maxRatingValue || $[22] !== movieActivityContext.activity?.movieStats || $[23] !== movieActivityContext.activity?.movieUserInteraction?.rating || $[24] !== movieActivityContext.activity?.movieUserInteraction?.review || $[25] !== movieIdentifier || $[26] !== onRatingPanelClose || $[27] !== showRatingPanel) {
    t7 = showRatingPanel && createPortal(<RatingPanel movieIdentifier={movieIdentifier} onClose={onRatingPanelClose} movieStats={movieActivityContext.activity?.movieStats} hasUserReview={!!movieActivityContext.activity?.movieUserInteraction?.review} userRating={movieActivityContext.activity?.movieUserInteraction?.rating} maxRatingValue={maxRatingValue} />, document.body);
    $[21] = maxRatingValue;
    $[22] = movieActivityContext.activity?.movieStats;
    $[23] = movieActivityContext.activity?.movieUserInteraction?.rating;
    $[24] = movieActivityContext.activity?.movieUserInteraction?.review;
    $[25] = movieIdentifier;
    $[26] = onRatingPanelClose;
    $[27] = showRatingPanel;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t8 = <div className={t2}>{t3}{t4}{t5}{t6}{t7}</div>;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  return t8;
}
//#endregion
function _temp(i) {
  return i + 1;
}